import React, { useState } from "react";
import "../style/Navbar.css";
import logo from "../assets/logo.png";
import { NavLink, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { useAuth } from "../context/AuthContext";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { userName, loading } = useAuth();

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/");
  };

  if (loading) return null;

  return (
    <header className="navbar">
      <div className="logo">
        <img src={logo} alt="logo" />
      </div>

      <div
        className={`nav-overlay ${menuOpen ? "open" : ""}`}
        onClick={toggleMenu}
      ></div>

      <nav className={menuOpen ? "open" : ""}>
        <ul>
          <li>
            <NavLink to="/" onClick={() => setMenuOpen(false)}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/store" onClick={() => setMenuOpen(false)}>
              Stores
            </NavLink>
          </li>
          <li>
            <NavLink to="/categories" onClick={() => setMenuOpen(false)}>
              Categories
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" onClick={() => setMenuOpen(false)}>
              Contact
            </NavLink>
          </li>

          {/* 📱 Mobile User Section */}
          <li className="mobile-login">
            {userName ? (
              <div className="user-actions">
                <span className="user-name-text">{userName}</span>
                <button className="logout-btn" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            ) : (
              <span
                onClick={() => {
                  navigate("/auth");
                  setMenuOpen(false);
                }}
                style={{ cursor: "pointer" }}
              >
                Log-In / Register
              </span>
            )}
          </li>
        </ul>
      </nav>

      {/* 🖥 Desktop User Section */}
      <div className="loginbar desktop-login">
        {userName ? (
          <div className="user-actions">
            <span className="user-name-text">{userName}</span>
            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </div>
        ) : (
          <span onClick={() => navigate("/auth")}>
            Log-In / Register
          </span>
        )}
      </div>

      <div
        className={`hamburger ${menuOpen ? "open" : ""}`}
        onClick={toggleMenu}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </header>
  );
};

export default Navbar;
